import createCache from '@emotion/cache';
/**
 * CSP nonceを使用してEmotionキャッシュを作成
 *
 * @description 本番環境でのCSP（Content Security Policy）対応のため、
 * meta[name="csp-nonce"]からnonceを取得してEmotionキャッシュに設定
 *
 * @returns EmotionのCache インスタンス
 *
 * @example
 * ```typescript
 * import { createEmotionCache } from '@shared/utils/emotion-cache';
 *
 * const emotionCache = createEmotionCache();
 * ```
 */
export function createEmotionCache() {
    // HTMLのmeta tagからCSP nonceを取得
    const nonceMeta = document.querySelector('meta[name="csp-nonce"]');
    const nonce = (nonceMeta === null || nonceMeta === void 0 ? void 0 : nonceMeta.getAttribute('content')) || undefined;
    return createCache({
        key: 'css',
        nonce: nonce,
    });
}
